import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Transaction from './pages/Transaction';
import Merchandise from './pages/Merchandise';
import Customer from './pages/Customer';
import Banner from './pages/Banner';
import Notfication from './pages/Notfication';
import Withdrawal from './pages/Withdrawal';
import Account from './pages/Account';
import Setting from './pages/Setting';
import Sales from './pages/Sales';
import Purchases from './pages/Purchases';
import Homepage from './pages/Homepage';
import Welcome from './pages/Welcome';
import Category from './pages/Category';
import CategoryDetail from './pages/CategoryDetail';
import Recipe from './pages/Recipe';
import RecipeDetails from './pages/RecipeDetails';
import FlashDeal from './pages/FlashDeal';
import FlashDealDetail from './pages/FlashDealDetail';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Profile from './pages/Profile';
import Help from './pages/Help';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Employee from './pages/Employee';
import Partner from './pages/Partner';
import Order from './pages/Order';
import Form from './pages/Form';
import SotoLamongan from './components/Dummy/SotoLamongan';
import TumisTahu from './components/Dummy/TumisTahu';
import DagingGoreng from './components/Dummy/DagingGoreng';
import SawiPages from './components/Dummy/SawiPages';
import BusinessPartner from './pages/BusinessPartner';
import CreateBanner from './pages/CreateBanner';
import CreateNotification from './pages/CreateNotification';
import CreateWithdrawal from './pages/CreateWithdrawal';
import AddAccount from './components/Account/AddAccount';
import EditWithdrawal from './pages/EditWithdrawal';

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/backoffice" component={Dashboard} />
      <Route path="/employee" component={Employee} />
      <Route path="/transaction" component={Transaction} />
      <Route path="/merchandise" component={Merchandise} />
      <Route path="/customer" component={Customer} />

      <Route path="/banner" component={Banner} />
      <Route path="/create-banner" component={CreateBanner} />

      <Route path="/notification" component={Notfication} />
      <Route path="/create-notification" component={CreateNotification} />

      <Route path="/withdraw" component={Withdrawal} />
      {/* <Route path="/account/add-account" component={CreateWithdrawal} /> */}

      {/* <Route path="/account" component={Account} /> */}
      <Route
        path="/account"
        render={({ match: { url } }) => (
          <>
            <Route path={`${url}/`} component={Account} exact />
            <Route path={`${url}/add-account`} component={CreateWithdrawal} />
            <Route path={`${url}/edit-account`} component={EditWithdrawal} />
          </>
        )}
      />

      <Route path="/setting" component={Setting} />
      <Route path="/sales" component={Sales} />
      <Route path="/purchases" component={Purchases} />
      <Route path="/homepage" component={Homepage} />
      <Route path="/welcome" component={Welcome} />
      <Route path="/category" component={Category} />
      <Route path="/recipe" component={Recipe} />
      <Route path="/details" component={RecipeDetails} />
      <Route path="/flash" component={FlashDeal} />
      <Route path="/flashdetail/" component={FlashDealDetail} />
      <Route path="/category-detail" component={CategoryDetail} />
      <Route path="/checkout" component={Checkout} />
      <Route path="/help" component={Help} />
      <Route path="/terms" component={Terms} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/checkout-success" component={CheckoutSuccess} />
      <Route path="/profile" component={Profile} />
      <Route path="/partner" component={Partner} />
      <Route path="/order" component={Order} />
      <Route path="/business-partner" component={BusinessPartner} />
      <Route path="/form" component={Form} />
      {/* dUmmy pages */}
      <Route path="/soto-lamongan" component={SotoLamongan} />
      <Route path="/sawi" component={SawiPages} />
      <Route path="/tumis-tahu" component={TumisTahu} />
      <Route path="/daging-goreng" component={DagingGoreng} />
      {/* End of dUmmy pages */}
      <Redirect from="/" to="/welcome" />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
